//import axios from 'axios';
import gql from 'graphql-tag';

export const MEGA_SCREENER_PARTIAL_SITE_SETTINGS_TEMPLATE_ID =
  process.env.NEXT_PUBLIC_MEGA_SCREENER_PARTIAL_SITE_SETTINGS_TEMPLATE_ID ||
  '{A32BDA93-DCC1-49E8-8029-7A2AAF6FC2C1}';

export const MEGA_SCREENER_DEFAULT_SITE_ROOT_PATH = '{0FA6966A-D464-4ADF-AD5C-154D0CAEE5FE}';

export type MegaScreenerPartialSiteSettingsItem = {
  tenantKey?: string;
  screenerPrimaryTAName?: string;
};

const MegaScreenerPartialSiteSettingsByTAQuery = gql`
  query MegaScreenerPartialSiteSettingsByTA(
    $rootItemId: String!
    $templateId: String!
    $language: String!
  ) {
    search(
      where: {
        AND: [
          { name: "_templates", value: $templateId }
          { name: "_language", value: $language }
          { name: "_path", value: $rootItemId, operator: CONTAINS }
        ]
      }
      first: 1000
    ) {
      total
      results {
        tenantKey: field(name: "tenantKey") {
          ... on TextField {
            jsonValue
          }
        }
        screenerPrimaryTA: field(name: "screenerPrimaryTA") {
          ... on ItemField {
            jsonValue
          }
        }
      }
    }
  }
`;

export const getMegaScreenerPartialSiteSettingsByTAQueryParameters = (
  language: string,
  rootItemId: string
) => ({
  rootItemId,
  templateId: MEGA_SCREENER_PARTIAL_SITE_SETTINGS_TEMPLATE_ID,
  language,
});

const toTrimmedString = (value: unknown): string | undefined =>
  value == null ? undefined : String(value).trim() || undefined;

/** Reads a single-line field `jsonValue` shaped as `{ value }`. */
const getFieldStringValue = (field: unknown): string | undefined => {
  if (field == null || typeof field !== 'object') return undefined;
  return toTrimmedString((field as { value?: unknown }).value);
};

/** Resolves droplink/lookup `jsonValue` name from `{ fields: { name: { value } } }`. */
const getReferenceFieldName = (field: unknown): string | undefined => {
  if (field == null || typeof field !== 'object') return undefined;
  const fields = (field as { fields?: Record<string, unknown> }).fields;
  return getFieldStringValue(fields?.name);
};

type PartialSiteSettingsGraphQLResult = {
  tenantKey?: { jsonValue?: unknown };
  screenerPrimaryTA?: { jsonValue?: unknown };
};

export const mapPartialSiteSettingsResults = (
  results: PartialSiteSettingsGraphQLResult[]
): MegaScreenerPartialSiteSettingsItem[] =>
  (results ?? []).map((item) => {
    const tenantKey = getFieldStringValue(item.tenantKey?.jsonValue);
    const screenerPrimaryTAName = getReferenceFieldName(item.screenerPrimaryTA?.jsonValue);

    return {
      ...(tenantKey ? { tenantKey } : {}),
      ...(screenerPrimaryTAName ? { screenerPrimaryTAName } : {}),
    };
  });

const findTenantKeyByTA = (
  partialSiteSettings: MegaScreenerPartialSiteSettingsItem[],
  ta?: string
): string | undefined =>
  ta
    ? partialSiteSettings.find(
        (item) => item.tenantKey && item.screenerPrimaryTAName?.toLowerCase() === ta.toLowerCase()
      )?.tenantKey
    : undefined;

export const resolveTenantKeyFromPartialSiteSettings = (
  partialSiteSettings: MegaScreenerPartialSiteSettingsItem[],
  lastScreenedTA: string | undefined
): string | undefined => {
  if (!partialSiteSettings.length) return undefined;

  return findTenantKeyByTA(partialSiteSettings, lastScreenedTA);
};

export default MegaScreenerPartialSiteSettingsByTAQuery;
